// react components
import React from 'react'
import {
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
} from 'data'

// serializers
import {
    ContentTypeDetailPanelTypes,
} from 'serializers/site'

// services
import {
    getReduxTextIdSite,
} from 'services'

// props
type DetailContentTabButton825Props = {
    panel: ContentTypeDetailPanelTypes
    setTab: React.Dispatch<React.SetStateAction<number>>
    tab: number
}

// main
export const DetailContentTabButton825: React.FC<DetailContentTabButton825Props> = React.memo(({
    panel,
    setTab,
    tab,
}) => {

    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    return (
        <button
            key={panel.id}
            className={(tab === panel.id) ? 'button-825 dc-active' : 'button-825'}
            onClick={() => setTab(panel.id)}
        >
            {getReduxTextIdSite(panel.title!, reduxText)}
        </button>
    )
})
